import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Lotus = () => {

return (

<div>

<Navbar />
<Flexproducts type="lotus" />
<Header></Header>

</div>

);
};

export default Lotus;